import { Injectable } from "@angular/core";
import { IQuiz } from "app/shared/models/quiz.interface";
import { EZoomPollQuestionType, IZoomMeetingPollCreateRequest, IZoomMeetingPollQuestions } from "./zoom";
import { BASEMysqlService } from "./_base";
@Injectable({
  providedIn: 'root'
})
export class MysqlServiceQuiz extends BASEMysqlService {

  prefix = 'quiz_'

  //////////////////////////////////////////////////////////////////////////////////////////

  list(idAzienda?: number): Promise<any> {
    let data = {
      auth: this.getAuth(),
      idAzienda: idAzienda
    }

    // console.log(data)

    return this.http.post(this.URL_BASE + this.prefix + 'list', data).toPromise();
  }

  get(id): Promise<any> {
    let data = {
      auth: this.getAuth(),
      id: id
    }

    // console.log(data)

    return this.http.post(this.URL_BASE + this.prefix + 'get', data).toPromise();
  }

  upsert(item: IQuiz): Promise<any> {
    let data = {
      auth: this.getAuth(),
      item: item
    }

    return this.http.post<any>(this.URL_BASE + this.prefix + 'upsert', data).toPromise();
  }

  delete(id: number): Promise<any> {
    let data = {
      auth: this.getAuth(),
      id: id
    }

    return this.http.post(this.URL_BASE + this.prefix + 'delete', data).toPromise();
  }

  validate(q: IZoomMeetingPollQuestions[]) {

    let i = 0

    let r = ''

    for (const e of q) {

      i++

      if (e.answer_min_character && e.answer_min_character < 1) {
        r +=  'answer_min_character non valido' + ` (Domanda ${i})` + ";\r\n     "
      }

      /*
      answers	
      Array of strings >= 2 items
      The poll question's available answers. This field requires a minimum of two answers.

      For single and multiple polls, you can only provide a maximum of 10 answers.
      For matching polls, you can only provide a maximum of 16 answers.
      For rank_order polls, you can only provide a maximum of seven answers.
      */

      if (e.answers?.length < 2) {
        r +=  'answers deve contenere almeno 2 elementi' + ` (Domanda ${i})` + ";\r\n     "
      }

      if (e.name.length > 255) {
        r +=  'name eccede 255 chars' + ` (Domanda ${i})` + ";\r\n     "
      }

      switch (e.type) {
        case EZoomPollQuestionType.SINGLE:
          if (e.answers?.length > 10) {
            r +=  'answers deve contenere al massimo 10 elementi' + ` (Domanda ${i})` + ";\r\n     "
          }

          for (const right_answer of e.right_answers) {

            let x = e.answers.find(s => s == right_answer)
            if (!x) {
              r +=  'Le risposte corrette devono corrispondere a quelle possibili' + ` (Domanda ${i})` + ";\r\n     "
            }

          }

          break;

        case EZoomPollQuestionType.MULTIPLE:
          for (const right_answer of e.right_answers) {

            let x = e.answers.find(s => s == right_answer)
            if (!x) {
              r +=  'Le risposte corrette devono corrispondere a quelle possibili' + ` (Domanda ${i})` + ";\r\n     "
            }

          }
          break

        case EZoomPollQuestionType.MATCHING:
          if (e.answers?.length > 16) {
            r +=  'answers deve contenere al massimo 16 elementi' + ` (Domanda ${i})` + ";\r\n     "
          }

          // For matching polls, you must provide a minimum of two correct answers, up to a maximum of 10 correct answers.
          for (const e1 of e.prompts) {
            if (e1.prompt_right_answers?.length < 2 || e1.prompt_right_answers?.length > 10) {
              r +=  'prompt_right_answers deve essere compreso tra 2 e 16' + ` (Domanda ${i})` + ";\r\n     "
            }
          }

          for (const prompt of e.prompts) {

            for (const right_answer of prompt.prompt_right_answers) {

              let x = e.answers.find(s => s == right_answer)
              if (!x) {
                r +=  'Le risposte corrette devono corrispondere a quelle possibili' + ` (Domanda ${i})` + ";\r\n     "
              }

            }

          }



          break;

        case EZoomPollQuestionType.RANK_ORDER:
          if (e.answers?.length > 7) {
            r +=  'answers deve contenere al massimo 7 elementi' + ` (Domanda ${i})` + ";\r\n     "
          }

          // For rank_order polls, you can only provide one correct answer.
          for (const e1 of e.prompts) {
            if (e1.prompt_right_answers?.length != 1) {
              r +=  'prompt_right_answers deve essere 1' + ` (Domanda ${i})` + ";\r\n     "
            }
          }


          for (const prompt of e.prompts) {

            for (const right_answer of prompt.prompt_right_answers) {

              let x = e.answers.find(s => s == right_answer)
              if (!x) {
                r += 'Le risposte corrette devono corrispondere a quelle possibili' + ` (Domanda ${i})` + ";\r\n     "
              }

            }

          }

          break;
      }

    }






    return r == '' ? true : r

  }

}